import type { MetadataEntity } from '../metadata-entity';

import { Property } from './property-metadata.decorator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ViewEmptyValue(viewEmptyValue: number | string) {
	return function(model: MetadataEntity, property: string): void {
		Property({ viewEmptyValue })(model, property);
	};
}
